class NotifyMe extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.id;
    if (!this.productId) return;

    this.selectors = this.selectors || {};
    this.selectors.form = this.querySelector('form');
    this.selectors.email = this.querySelector('input[type="email"]');
    this.selectors.notifyModal = this.querySelector('[data-notify-me-modal]');
    this.selectors.notifyOpenBtn = this.querySelector('[data-notify-modal-open]');
    this.selectors.notifyCloseBtn = this.querySelector('[data-notify-modal-close]');
    this.selectors.notifySuccessMsg = this.querySelector('[data-notify-success-msg]');
    this.selectors.notifyProductGrid = this.closest('[data-product-id]');

    this.selectors.notifyOpenBtn.addEventListener('click', this.show.bind(this));
    this.selectors.notifyCloseBtn.addEventListener('click', this.hide.bind(this));
    this.selectors.form?.addEventListener('submit', this.submit.bind(this));

    // Add real-time email validation
    if (this.selectors.email) {
      this.selectors.email.addEventListener('blur', this.validateEmailField.bind(this));
      this.selectors.email.addEventListener('input', this.clearEmailError.bind(this));
    }

    // Add event listener for collection submit button if it exists
    const collectionSubmitBtn = this.querySelector('button[type="submit"]');
    if (collectionSubmitBtn) {
      collectionSubmitBtn.addEventListener('click', this.collectionOnSubmitBISForm.bind(this));
    }
  }

  collectionOnSubmitBISForm(event) {
    event.preventDefault();

    let hasError = false;
    let msg = '';
    let productSKU = '';
    let email = null;

    function isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    // Find the visible notify-me modal
    const elements = document.querySelectorAll('.notify-me-modal');
    let visibleModal = null;

    elements.forEach((el) => {
      if (isVisible(el)) {
        visibleModal = el;
        email = el.querySelector('[name="email"]');

        // Try to find the product SKU from the button that triggered this
        const triggerBtn = event.target;
        if (triggerBtn) {
          productSKU =
            triggerBtn.getAttribute('offer-var-id') || triggerBtn.getAttribute('data-variant-id');
        }

        // Fallback: try to find from parent elements
        if (!productSKU) {
          const parent = el.closest('notify-me');
          if (parent) {
            const btn = parent.querySelector('.notify-btn, [offer-var-id], [data-variant-id]');
            if (btn) {
              productSKU = btn.getAttribute('offer-var-id') || btn.getAttribute('data-variant-id');
            }
          }
        }
      }
    });

    if (!email) {
      console.error('Email input not found in visible modal');
      return;
    }

    let emailAddress = email.value;
    emailAddress = emailAddress ? emailAddress.trim() : emailAddress;

    // Get alert code from hidden input or use default
    const alertCodeInput = document.getElementById('hdnAlertCode');
    const alertCode = alertCodeInput ? alertCodeInput.value : 'BIS';

    // Validate email using standard regex
    if (emailAddress === '') {
      hasError = true;
      msg = 'Email field is required';
    } else {
      // Standard email regex validation
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
      if (!emailRegex.test(emailAddress)) {
        hasError = true;
        msg = 'Please enter a valid email address';
      }
    }

    if (!hasError && productSKU) {
      // Submit the alert
      if (window._ltk) {
        _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
        _ltk.Alerts.Submit();
      }

      if (window._theme && window._theme.track) {
        _theme.track.trackData({ event: 'notifyMeFormSubmitted' });
      }

      alert('Thank you! We will notify you when this product becomes available.');
      document.querySelector('body').style.overflow = '';

      // Hide the modal if it exists
      if (visibleModal) {
        visibleModal.style.display = 'none';
      }

      // Hide wrapper if it exists
      const wrapper = document.querySelector('.product_alert_signup_wrapper');
      if (wrapper) {
        wrapper.classList.add('hide');

      }
    } else {
      // Show error message
      const errorContainer = visibleModal ? visibleModal.querySelector('.input-error') : null;
      if (errorContainer) {
        errorContainer.innerHTML = '';
        const newSpan = document.createElement('span');
        newSpan.setAttribute('role', 'alert');
        newSpan.textContent = msg;
        errorContainer.appendChild(newSpan);
        errorContainer.style.display = 'block';
        email.focus();
      } else {
        console.error('Error container not found');
      }
    }
  }

  show() {
    this.selectors.notifyModal.style.display = 'block';
    if (this.selectors.notifyProductGrid != null) {
      this.selectors.notifyProductGrid?.classList.remove('sold_out_item');
    }
    document.querySelector('body').style.overflow = 'hidden';
    _theme.focusTrap($(this.selectors.notifyModal), () => {
      this.hide();
    });
  }

  hide() {
    this.selectors.notifyModal.style.display = 'none';
    if (this.selectors.notifyProductGrid != null) {
      this.selectors.notifyProductGrid?.classList.add('sold_out_item');
    }
    document.querySelector('body').style.overflow = '';
    this.reset();
    this.selectors.notifyOpenBtn.focus();
  }

  submit(event) {
    event.preventDefault();

    const emailVal = this.selectors.email.value.trim();
    const errorElem = this.querySelector('.input-error');
    errorElem.classList.add('hidden');

    // Standard email regex validation
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
    const isValid = emailRegex.test(emailVal);

    if (isValid) {
      const alertCode = 'BIS';
      this.submitDetails(emailVal, this.productId, alertCode);
      this.showSuccessMsg();
      setTimeout(this.hide.bind(this), 3000);
    } else {
      this.selectors.email.focus();
      errorElem.classList.remove('hidden');
    }
  }

  submitDetails(emailAddress, productSKU, alertCode) {
    if (!window._ltk) return false;
    if (!emailAddress || !productSKU || !alertCode) return false;

    _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
    _ltk.Alerts.Submit();
    _theme.track.trackData({ event: 'notifyMeFormSubmitted' });
    return true;
  }

  showSuccessMsg() {
    this.selectors.notifyModal.querySelector('.notify-modal-header').classList.add('hidden');
    this.selectors.notifyModal.querySelector('.notify-modal-footer').classList.add('hidden');
    this.selectors.form.classList.add('hidden');
    this.selectors.notifySuccessMsg.classList.remove('hidden');
  }

  reset() {
    this.selectors.notifyModal.querySelector('.notify-modal-header').classList.remove('hidden');
    this.selectors.notifyModal.querySelector('.notify-modal-footer').classList.remove('hidden');
    this.selectors.form.classList.remove('hidden');
    this.selectors.notifySuccessMsg.classList.add('hidden');
    this.selectors.email.value = '';
    this.clearEmailError();
  }

  validateEmailField() {
    const emailVal = this.selectors.email.value.trim();
    const errorElem = this.querySelector('.input-error');

    if (emailVal) {
      // Standard email regex validation
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
      const isValid = emailRegex.test(emailVal);

      if (!isValid) {
        errorElem.classList.remove('hidden');
        this.selectors.email.setAttribute('aria-invalid', 'true');
      } else {
        errorElem.classList.add('hidden');
        this.selectors.email.setAttribute('aria-invalid', 'false');
      }
    }
  }

  clearEmailError() {
    const errorElem = this.querySelector('.input-error');
    errorElem.classList.add('hidden');
    this.selectors.email.setAttribute('aria-invalid', 'false');
  }
}
customElements.define('notify-me', NotifyMe);
